var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadReportImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1094_3783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.06 14H2.93999C2.07332 14 1.59578 14 1.14659 13.7711C0.748856 13.5684 0.431548 13.2511 0.228899 12.8534C0 12.4041 0 11.9266 0 11.0599V6.30025C0 5.91363 0.313319 5.60029 0.699927 5.60029C1.08653 5.60029 1.39985 5.91363 1.39985 6.30025V11.0599C1.39985 11.667 1.39985 12.0679 1.47608 12.2177C1.5437 12.3502 1.64933 12.456 1.78205 12.5236C1.93178 12.5999 2.33288 12.5999 2.93999 12.5999H11.06C11.6671 12.5999 12.068 12.5999 12.2177 12.5236C12.3505 12.456 12.4561 12.3504 12.5237 12.2177C12.5999 12.0679 12.5999 11.6668 12.5999 11.0597V6.30004C12.5999 5.91342 12.9133 5.60008 13.2999 5.60008C13.6865 5.60008 13.9998 5.91342 13.9998 6.30004V11.0597C13.9998 11.9264 13.9998 12.4039 13.7709 12.8531C13.5682 13.2509 13.2509 13.5682 12.8532 13.7709C12.404 13.9998 11.9269 14 11.06 14ZM7.00011 9.80046C6.90477 9.80046 6.81384 9.78135 6.7311 9.74691C6.64899 9.71268 6.57192 9.66228 6.50514 9.59549L3.70522 6.79545C3.4318 6.52202 3.4318 6.0789 3.70522 5.80547C3.97864 5.53204 4.42174 5.53204 4.69516 5.80547L6.30018 7.41057V0.699958C6.30018 0.313333 6.6135 0 7.00011 0C7.38671 0 7.70003 0.313333 7.70003 0.699958V7.41036L9.30505 5.80526C9.57847 5.53183 10.0216 5.53183 10.295 5.80526C10.5684 6.07869 10.5684 6.52181 10.295 6.79524L7.49507 9.59528C7.42829 9.66207 7.35143 9.71247 7.26932 9.7467C7.18638 9.78114 7.09566 9.80046 7.00011 9.80046Z",
    fill: "#444C5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1094_3783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReportImage);
export default __webpack_public_path__ + "static/media/download-report-image.7e584ad715f9fea53487010faafe8915.svg";
export { ForwardRef as ReactComponent };